import { therapyItems } from '@alberta/konexi-shared';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'therapy',
})
export class Therapy2Pipe implements PipeTransform {
  transform(value: any, ...args) {
    if (value === 'undefined' || isNaN(value)) {
      return 'sonstige Dokumente';
    }

    const retVal = therapyItems.find(therapyItem => therapyItem.id === Number(value));

    if (retVal) {
      return retVal.displayName;
    }
  }
}
